import { createReducer, on } from '@ngrx/store';
import { setSelectedAccount, setSelectedAddress } from './account-selection.actions'; // ajuste o caminho conforme necessário

export interface AccountSelectionState {
  displayAccount: string;
  displayAddress: string;
}

export const initialState: AccountSelectionState = {
  displayAccount: '',
  displayAddress: '',
};

export const accountSelectionReducer = createReducer(
  initialState,

  on(setSelectedAccount, (state, { displayAccount }) => ({
    ...state,
    displayAccount,
  })),

  on(setSelectedAddress, (state, { displayAddress }) => ({
    ...state,
    displayAddress,
  })),
);
